import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell, LinkCell } from '@abra/elements/table/cells/basics/'

import FormatUtils from '@front/squirtle/utils/format'
import { hooks } from '@front/volcanion'
import AssociatedInfoComponent from '@abra/elements/event/Data/'

const Row = ({ row }) => {
  const [{ name: operator_name }] = hooks.useCustomerInfo(row?.operator?.user_id)
  return <>
    <TableCell size={'small'}><TextCell value={FormatUtils.formatDateBackToFront(_.get(row, 'createdAt'))} /></TableCell>
    <TableCell size={'small'}><TextCell value={operator_name} /></TableCell>
    <TableCell size={'small'}><TextCell value={_.get(row, 'name')} /></TableCell>
    <TableCell size={'small'}><AssociatedInfoComponent data={row?.data || []} /></TableCell>
    <TableCell size={'small'}><LinkCell value={_.get(row, 'group.group_client_id')} href={`/group/${_.get(row, 'group.group_id')}`} /></TableCell>
  </>
}

export default React.memo(Row)
